// extracted by mini-css-extract-plugin
export default {"menu":"AccountMenu_menu__QifRj","menuItem":"AccountMenu_menuItem__WIOsq","menuItemAdmin":"AccountMenu_menuItemAdmin__tWKCJ"};